export default __webpack_public_path__ + "static/media/477.03fa3696.png";